import { Text } from 'src/modules/shared/components/atoms/text';
import type { PropertyLinkEditorStepProps } from '../../../types/property-links.types';

/** Make the example-to-variable-to-preview progression visible. */
export function PropertyLinkEditorStep({
  step,
  title,
  description,
  action,
  children,
}: PropertyLinkEditorStepProps) {
  return (
    <section className="space-y-3" aria-label={title}>
      <div className="flex flex-wrap items-start gap-3">
        <Text
          as="span"
          size="tiny"
          weight="medium"
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100"
        >
          {step}
        </Text>
        <div className="min-w-0 flex-1 space-y-1">
          <Text as="h5" size="small" weight="medium">
            {title}
          </Text>
          {description && (
            <Text size="small" color="secondary">
              {description}
            </Text>
          )}
        </div>
        {action}
      </div>
      <div className="space-y-3 sm:pl-9">{children}</div>
    </section>
  );
}
